import React, {PropTypes} from 'react';
import moment from 'moment';

const CapacitySquadItem  = ({
  id,
  eventName,
  date,
  totalEntries,
  numberSold,
  numberAvailableForPurchase,
  hideFromCaptains,
  dirty,
  onSquadCapacityBlur,
  onSquadCapacityChange,
  onSquadVisibilityChange
}) => (
  <div className="list-group-item-labeled">
    <div
      style={{width: 150}}
      className="list-group-item-labeled-child"
    >
      <span>{'Name'}</span>
      <span>{eventName}</span>
    </div>
    <div
      style={{width: 150}}
      className="list-group-item-labeled-child"
    >
      <span>{'Date'}</span>
      <span>{moment.parseZone(date).format('D MMM, hh:mm A')}</span>
    </div>
    <div
      style={{width: 100}}
      className="list-group-item-labeled-child"
    >
      <span>{'Total Entries'}</span>
      <span>{totalEntries}</span>
    </div>
    <div
      style={{width: 100}}
      className="list-group-item-labeled-child"
    >
      <span>{'# Sold'}</span>
      <span>{numberSold}</span>
    </div>
    <div className="list-group-item-labeled-child">
      <span>{'Available For Purchase'}</span>
      <input
        type="number"
        min="0"
        step="1"
        max={totalEntries}
        value={numberAvailableForPurchase}
        disabled={!totalEntries}
        onChange={event => onSquadCapacityChange(id, event.target.value)}
        onBlur={event => onSquadCapacityBlur({
          squadId: id,
          inputValue: event.target.value,
          dirty
        })}
      />
    </div>
    <div
      style={{width: 115}}
      className="list-group-item-labeled-child">
      <span
        style={{margin: 'auto'}}>{'Hide From Captains'}</span>
      <input
        style={{margin: 'auto'}}
        type="checkbox"
        id={id}
        checked={hideFromCaptains}
        onChange={() => onSquadVisibilityChange(id, !hideFromCaptains)}
      />
    </div>
  </div>
);

CapacitySquadItem.propTypes = {
  id: PropTypes.string,
  eventName: PropTypes.string,
  date: PropTypes.string,
  totalEntries: PropTypes.number,
  numberSold: PropTypes.number,
  numberAvailableForPurchase: PropTypes.number,
  hideFromCaptains: PropTypes.bool,
  dirty: PropTypes.bool,
  onSquadCapacityBlur: PropTypes.func,
  onSquadCapacityChange: PropTypes.func,
  onSquadVisibilityChange: PropTypes.func
};

export default CapacitySquadItem;



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/CapacitySquadItem.jsx